import React from "react";
import { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css"; // Import CSS của AOS
import Header from "../../components/header";
import Footer from "../../components/footer";
import GiftDetailModal1 from "../../components/giftDetailModal1";
import GiftDetailModal2 from "../../components/giftDetailModal2";
import GiftDetailModal3 from "../../components/giftDetailModal3";
import mainImage from "../../assets/phanqua.png";
import titleMobile from "../../assets/tileMobile.png";
import frame from "../../assets/frame.png";
import gift1 from "../../assets/gift1.png";
import title from "../../assets/title1.png";
import gift2 from "../../assets/gift2.png";
import gift3 from "../../assets/gift3.png";
import gift4 from "../../assets/gift4.png";
import gift5 from "../../assets/gift6.png";
import gift6 from "../../assets/gift5.png";
import Evaluate from "../../assets/evaluate.png";
import titleEvaluate from "../../assets/titleEvaluate.png";
import iconVote from "../../assets/iconVote.png";
import vote from "../../assets/vote.png";
import logoVote from "../../assets/logoVote.png";
import { Carousel } from "primereact/carousel";
import "primereact/resources/themes/lara-light-indigo/theme.css"; // Theme
import "primereact/resources/primereact.min.css"; // Core CSS
import "primeicons/primeicons.css";
import "./index.css";
import customerReview from "../../assets/KHÁCH HÀNG ĐÁNH GIÁ.png";
import khuyenmai from "../../assets/KHUYẾN MÃI.png";
import axios from "axios";
import { Modal } from "antd";

const HomePage = () => {
  const [activeModal, setActiveModal] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeButton, setActiveButton] = useState(0);
  const [dataPromotion, setDataPromotion] = useState();
  const [isPaused, setIsPaused] = useState(false);
  const [contentData, setContentData] = useState()
  const [isShowPromotion, setIsShowPromotion] = useState(false)

  const activeStyle = {
    color: "white",
    backgroundImage: "url(/images/bgButton.png)",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  };

  const buttons = [
    {
      title: "Trang chủ",
      link: "https://www.rr311.com/",
    },
    {
      title: "Đặc Quyền Vip",
      link: "https://www.rr311.com/promotions?id=3125657",
    },
    {
      title: "Đại lý",
      link: "https://dailyrr88.pages.dev/",
    },
    {
      title: "Khuyến Mãi",
      link: "https://rr88ttkm.com/",
    },
    {
      title: "Cskh 24/7",
      link: "https://ttdvkh.rr88cskh.com/",
    },
  ];

  useEffect(() => {
    AOS.init({
      duration: 1000, // Thời gian hiệu ứng
      easing: "ease-out-back", // Loại hiệu ứng (tùy chọn)
      once: false, // Chỉ chạy hiệu ứng một lần
    });
  }, []);

  const openModal = (index) => {
    setIsModalOpen(true);
    setActiveModal(index);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setActiveModal(null);
  };

  const responsiveOptions = [
    {
      breakpoint: "1400px",
      numVisible: 2,
      numScroll: 1,
    },
    {
      breakpoint: "1199px",
      numVisible: 2,
      numScroll: 1,
    },
    {
      breakpoint: "767px",
      numVisible: 1,
      numScroll: 1,
    },
    {
      breakpoint: "575px",
      numVisible: 1,
      numScroll: 1,
    },
  ];

  const dataVote = [
    {
      comment: "Loa bluetooth êm lắm. Cảm ơn RR88",
      name: "Bin8**",
      level: "Vip10",
    },
    {
      comment: "Áo đẹp quá, chất lượng vải rất đẹp.",
      name: "linhkk**",
      level: "Vip5",
    },
    {
      comment: "Cảm ơn RR88, bộ ấm trà rất đẹp.",
      name: "quan79**",
      level: "Vip7",
    },
    {
      comment: "Mình đã nhận được quà. Cảm ơn RR88 rất nhiều.",
      name: "Abc**",
      level: "Vip10",
    },
    {
      comment: "Trên cả tuyệt vời luôn nha.",
      name: "Cubin55**",
      level: "Vip9",
    },
    {
      comment: "Bao ngày chờ đợi áo cũng đã về, chất lượng quá tốt.",
      name: "thanhminh**",
      level: "Vip10",
    },
    {
      comment:
        "Đội ngũ CSKH chuyên nghiệp, quà thì chất lượng không chê vào đâu được",
      name: "minh88**",
      level: "Vip9",
    },
    {
      comment: "Đã nhận được quà từ RR88, chất lượng tốt nha.",
      name: "Quyxom**",
      level: "Vip10",
    },
    {
      comment: "Nhận được loa nghe rất ok, Bass rất căng nha",
      name: "anhto**",
      level: "Vip8",
    },
    {
      comment: "Quà tặng RR88 quá chất lượng nha. Very Good!",
      name: "hao79**",
      level: "Vip10",
    },
  ];

  const voteTemplate = (item, index) => {
    return (
      <div
        key={index}
        className="w-[99%] h-full border p-3 rounded-[20px] shadow-lg mx-1 "
      >
        <div className="flex justify-between">
          <img src={iconVote} alt="" className="md:w-10 w-7" />
          <img src={vote} alt="" className="md:w-[100px] w-[50px]" />
        </div>
        <div className="my-3 border-b-2 pb-3 md:text-[15px] text-[11px] font-semibold ">
          {item.comment}
        </div>
        <div className="flex gap-2 ">
          <img src={logoVote} alt="" className="md:w-[60px] w-[30px] h-7" />
          <div className="md:text-[15px] text-[11px]">
            <h3 className="font-semibold">{item.name}</h3>
            <p>{item.level}</p>
          </div>
        </div>
      </div>
    );
  };

  const handleClick = (item) => {
    setContentData(item.contents[0].content);
    setIsShowPromotion(true)
    
  }
  
  const MissonTemplate = (item, index) => {
    return (
      <div className=" mx-auto w-[99%] " key={index} onClick={() =>  handleClick(item)}>
        <img
          src={item.announcementImages[0].url}
          alt=""
          className="w-full h-full"
        />
      </div>
    );
  };
  useEffect(() => {
    const isMobile = window.innerWidth <= 768;

    if (isMobile) {
      axios
        .get(process.env.REACT_APP_API_URL_PROMOTION)
        .then((data) => setDataPromotion(data.data.data))
        .catch((err) => console.error(err));
    } else {
      axios
        .get(`${process.env.REACT_APP_API_URL_PROMOTION}?platform=M`)
        .then((data) => setDataPromotion(data.data.data))
        .catch((err) => console.error(err));
    }
  }, []);

const PromotionContent = () => {
    return (
        <div 
        dangerouslySetInnerHTML={{ __html: contentData }}  />
    );
}

console.log(contentData);

  return (
    <>
      <Header />
      <div className="md:block hidden ">
        <div className=" w-full bg-cover bg-center">
          <img
            src={mainImage}
            alt="background"
            className="w-[full]  object-cover "
          />
        </div>
        <div
          className={`marquee-container ${isPaused ? "paused" : ""}`}
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
        >
          <div className="marquee-content">
            <ul className="notice-list !py-2">
              {dataPromotion?.player.map((item, index) => (
                <li key={index}>{item.title}</li>
              ))}
            </ul>
            {/* Repeat for infinite loop effect */}
          </div>
        </div>
        <div className="text-center mx-auto max-w-7xl flex flex-col gap-[50px] mt-[50px]">
          <div className="">
            <img
              src={title}
              alt="background"
              className="w-auto h-auto object-cover m-auto"
            />
          </div>
          <div className="!text-black border w-[780px] h-[60px] rounded-[50px] mx-auto text-[20px] font-semibold flex gap-3 justify-center shadow-xl">
            {buttons.map((item, index) => (
              <button
                key={index}
                className="w-[139px] h-[40px] my-auto rounded-[29px]"
                onClick={() => setActiveButton(index)}
                style={activeButton === index ? activeStyle : {}}
              >
                <a href={item.link}>
                {item.title}
                </a>
              </button>
            ))}
          </div>

          <div>
            <div className="grid grid-cols-2 sm:grid-cols-6 lg:grid-cols-3 gap-4">
              {[gift2, gift3, gift1, gift4, gift5, gift6].map(
                (image, index) => (
                  <div
                    key={index}
                    className=" transition-transform duration-300 ease-in-out"
                    data-aos="fade-up"
                    data-aos-delay="10"
                  >
                    <img
                      src={image}
                      alt={`image-${index}`}
                      className="w-full h-full object-cover rounded-lg shadow-md hover:scale-110 transition-transform duration-300 ease-in-out cursor-pointer bg-cover bg-center"
                      onClick={() => openModal(index)}
                    />
                  </div>
                )
              )}
            </div>
          </div>
          <div>
            <img src={titleEvaluate} alt="" className="mx-auto" />
          </div>
          <div>
            <div className="card">
              <Carousel
                value={dataVote}
                numScroll={1}
                numVisible={2}
                responsiveOptions={responsiveOptions}
                itemTemplate={voteTemplate}
              />
            </div>
          </div>
          <div>
            <img src={Evaluate} alt="" className="mx-auto" />
          </div>
          <div>
            <div className="card">
              <Carousel
                value={dataPromotion?.promotion || []}
                numScroll={1}
                numVisible={2}
                responsiveOptions={responsiveOptions}
                itemTemplate={MissonTemplate}
              />
            </div>
          </div>
          <Modal open={isShowPromotion} onCancel={() => setIsShowPromotion(false)}  className="!w-[1000px]" footer={null}>
            {PromotionContent()}

          </Modal>
        </div>
      </div>

      {/* mobile */}
      <div className="md:hidden block">
        <div className="flex items-center justify-center bg-cover bg-center">
          <img src={mainImage} alt="background" />
        </div>
        <div
          className={`marquee-container ${isPaused ? "paused" : ""}`}
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
        >
          <div className="marquee-content">
            <ul className="notice-list !py-2">
              {dataPromotion?.player.map((item, index) => (
                <li key={index}>{item.title}</li>
              ))}
            </ul>
            {/* Repeat for infinite loop effect */}
          </div>
        </div>
        <div className=" flex items-center justify-center w-full">
          <div className="flex  text-[#2B8DFE] font-semibold text-[1.7rem] mt-5 font-extrabold ">
            <img src={titleMobile} alt="" className="w-[250px]" />
          </div>
        </div>
        <div className="container mx-auto px-4 my-5">
          <div className="grid grid-cols-2 sm:grid-cols-2 gap-8 items-center justify-center">
            {[gift2, gift3, gift1, gift4, gift5, gift6].map((image, index) => (
              <div
                key={index}
                className="flex flex-col items-center justify-center transition-transform duration-300 ease-in-out text-[0.7rem]"
                data-aos="fade-up"
                data-aos-delay="10"
              >
                <img
                  src={image}
                  alt={`image-${index}`}
                  className="object-cover rounded-lg shadow-md hover:scale-110 transition-transform duration-300 ease-in-out cursor-pointer"
                  onClick={() => openModal(index)}
                />
              </div>
            ))}
          </div>
        </div>
        <div>
          <img src={customerReview} alt="" className="mx-auto my-5" />
        </div>
        <div>
          <div className="card">
            <Carousel
              value={dataVote}
              numScroll={1}
              numVisible={2}
              responsiveOptions={responsiveOptions}
              itemTemplate={voteTemplate}
            />
          </div>
        </div>
        <div>
          <img src={khuyenmai} alt="" className="mx-auto mb-5" />
        </div>
        <div>
          <div className="card">
            <Carousel
              value={dataPromotion?.promotion || []}
              numScroll={1}
              numVisible={2}
              responsiveOptions={responsiveOptions}
              itemTemplate={MissonTemplate}
            />
          </div>
        </div>
      </div>
      <Footer />
      {activeModal === 0 && (
        <GiftDetailModal1 isOpen={isModalOpen} closeModal={closeModal} />
      )}
      {activeModal === 1 && (
        <GiftDetailModal2 isOpen={isModalOpen} closeModal={closeModal} />
      )}
      {activeModal === 2 && (
        <GiftDetailModal3 isOpen={isModalOpen} closeModal={closeModal} />
      )}
    </>
  );
};

export default HomePage;
